export const CONTACT_METHODS = {
  PHONE: `phone`,
  LIVE_CHAT: `liveChat`,
  EMAIL: `email`,
  CALL_BACK: `callBack`,
  CALL: "call",
  CHAT: "chat",
}
